<template>
    <b-modal v-if="!loading" id="product_category_form" ref="product_category_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add Product Category' : 'Edit Product Category' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Description" class="has-float-label">
                        <template v-slot:label>
                            <span>Description <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.description" :class="{'border-danger': 'description' in errors}"
                                      @input="'description' in errors ? delete errors.description : ''"
                                      autocomplete="off" placeholder="Description"/>

                        <b-form-invalid-feedback :state="!'description' in errors"
                                                 v-text="'description' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group class="mb-4">
                        <b-form-file v-model="image" placeholder="Choose a picture..."/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Parent_Category" class="has-float-label">
                        <template v-slot:label>
                            <span>Parent Category <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateParentCategory" v-model="selected.category" :options="parent_categories"
                                  :border-danger="'parent_category_id' in errors"/>

                        <b-form-invalid-feedback :state="!'parent_category_id' in errors"
                                                 v-text="'parent_category_id' in errors ? errors.parent_category_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('product_category_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitProductCategory">Submit</state-button>

            <state-button v-else variant="primary" :click="updateProductCategory">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import StateButton from "../../../../../components/Common/StateButton";


    export default {
        name: "ProductCategoryFormModal",

        components: {
            StateButton,
        },

        props: [
            'edit'
        ],

        data() {
            return{
                loading: true,
                image: null,
                selected: {
                    categories: [],
                },
            }
        },

        computed: {
            ...mapGetters({
                form: 'getProductCategoryForm',
                errors: 'getProductCategoryErrors',
                parent_categories: 'getSelectParentCategories'
            })

        },

        mounted() {
            this.loading = false;
        },

        methods: {
            resetForm() {
                this.$store.commit('setProductCategoryForm');

                this.selected.category = [];
            },

            updateParentCategory(field) {
                if (field) {
                    this.form.parent_category_id = field.parent_category_id;
                } else {
                    this.form.parent_category_id = '';
                }
                'parent_category_id' in this.errors ? delete this.errors.parent_category_id : '';
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            submitProductCategory() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitProductCategory', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new category!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_category_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            updateProductCategory() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateProductCategory', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the product category!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_category_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            }
        }
    }
</script>

<style scoped>

</style>
